/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ScopeFilterZone {
    getFixupPrototypeFunction() { return ScopeFilterZone.fixupPrototype; }

    static newInstance(model: Partial<ScopeFilterZone>): ScopeFilterZone {
        let obj = Object.assign(new ScopeFilterZone(), model);
        ScopeFilterZone.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ScopeFilterZone>): ScopeFilterZone {
        if (!model) return null;
        return ScopeFilterZone.newInstance(<ScopeFilterZone> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ScopeFilterZone) {
        if (!obj) return;

        models.ScopeFilterZone.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ScopeFilterZone): boolean {
        Object.setPrototypeOf(obj, ScopeFilterZone.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Name for zone
     */
    name: string;

    /**
     * Id for zone
     */
    id: string;

    /**
     * Zone_id for zone
     */
    zone_id: string;

    /**
     * Region for zone
     */
    region: string;

}
